import { useMemo } from "react";
import {
  canDelete,
  canEditField,
  hasRightsForAction,
} from "@/react/features/globalization/rights";
import {
  INTERNATIONAL_NUMBERING_DELETE,
  INTERNATIONAL_LNP_FIELDS_EDIT,
  INTERNATIONAL_NUMBER_TYPE_CREATE,
  INTERNATIONAL_NUMBERING_FIELDS_EDIT,
  INTERNATIONAL_LNP_DELETE,
  INTERNATIONAL_LNP_CREATE,
  INTERNATIONAL_NUMBERING_CREATE,
} from "@/react/features/globalization/constants";

const useHasRights = (rights) => {
  const canEditLnp = useMemo(() => {
    return {
      create: hasRightsForAction(rights, INTERNATIONAL_LNP_CREATE),
      number_type_create: hasRightsForAction(
        rights,
        INTERNATIONAL_NUMBER_TYPE_CREATE
      ),
      number_type: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "number_type"
      ),
      status: canEditField(rights, INTERNATIONAL_LNP_FIELDS_EDIT, "status"),
      lead_time: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "lead_time"
      ),
      change_lead_time: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "change_lead_time"
      ),
      porting_windows: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "porting_windows"
      ),
      in_country_format: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "in_country_format"
      ),
      porting_carrier: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "porting_carrier"
      ),
      country_code: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "country_code"
      ),
      required_documents: canEditField(
        rights,
        INTERNATIONAL_LNP_FIELDS_EDIT,
        "required_documents"
      ),
      delete: canDelete(rights, INTERNATIONAL_LNP_DELETE),
    };
  }, [rights]);
  const canEditNumbering = useMemo(() => {
    return {
      create: hasRightsForAction(rights, INTERNATIONAL_NUMBERING_CREATE),
      number_type_create: hasRightsForAction(
        rights,
        INTERNATIONAL_NUMBER_TYPE_CREATE
      ),
      number_type: canEditField(
        rights,
        INTERNATIONAL_NUMBERING_FIELDS_EDIT,
        "number_type"
      ),
      status: canEditField(
        rights,
        INTERNATIONAL_NUMBERING_FIELDS_EDIT,
        "status"
      ),
      SLA: canEditField(rights, INTERNATIONAL_NUMBERING_FIELDS_EDIT, "SLA"),
      in_country_format: canEditField(
        rights,
        INTERNATIONAL_NUMBERING_FIELDS_EDIT,
        "in_country_format"
      ),
      required_documents: canEditField(
        rights,
        INTERNATIONAL_NUMBERING_FIELDS_EDIT,
        "required_documents"
      ),
      service_restriction: canEditField(
        rights,
        INTERNATIONAL_NUMBERING_FIELDS_EDIT,
        "service_restriction"
      ),
      delete: canDelete(rights, INTERNATIONAL_NUMBERING_DELETE),
    };
  }, [rights]);

  return { lnp: canEditLnp, numberingDetails: canEditNumbering };
};

export default useHasRights;
